var map = {
	"./A.png": 633,
	"./B.png": 634,
	"./C.png": 635,
	"./D.png": 636,
	"./audio.png": 492,
	"./audio_img/confirm_cn.png": 493,
	"./audio_img/confirm_english.png": 494,
	"./audio_img/confirm_zh.png": 495,
	"./audio_img/question_cn.png": 496,
	"./audio_img/question_english.png": 497,
	"./audio_img/question_zh.png": 498,
	"./bg.png": 499,
	"./cn.png": 637,
	"./en.png": 638,
	"./idea.png": 500,
	"./rainbow.png": 501,
	"./son.png": 502,
	"./video_img/answer_cn.png": 503,
	"./video_img/answer_english.png": 504,
	"./video_img/answer_zh.png": 505,
	"./video_img/question_cn.png": 506,
	"./video_img/question_english.png": 507,
	"./video_img/question_zh.png": 508,
	"./zh.png": 639,
	"./zh_cn.png": 640,
	"./zh_tw.png": 641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1001;